import { CoreCapsuleWithAccount } from 'entities'
import { BigNumber } from 'ethers'
import { bigDiv, formatBigNumber } from 'utils'

export const RISK_PROMPT_RATIO = 0.85
// Actions that generate a borrow usage over 85% (RISK_PROMPT_RATIO) show risk acknowledgment prompt
export function isRiskyAction(
  input: BigNumber | undefined,
  coreCapsule: CoreCapsuleWithAccount,
  futureLTV: BigNumber | null,
) {
  if (!input || !coreCapsule.accountProperties || !futureLTV) {
    return false
  }

  const { maxLTV } = coreCapsule.accountProperties
  const newBorrowUsage = bigDiv(futureLTV, maxLTV)

  return Number(formatBigNumber(newBorrowUsage)) > RISK_PROMPT_RATIO
}
